import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiPencil, mdiExportVariant, mdiTextBoxPlusOutline, mdiBlurRadial } from '@mdi/js';

import { _ } from '../../functions/translator'
import { GoTriangleRight, GoTriangleDown  } from "react-icons/go";

class DropdownButton extends React.Component{
          
    render(){   
        
        const buttonName = _(this.props.title)
        let icon = ''
        let iconClass = 'mx-2'
        let iconSize = '30px'
        let iconColor = 'white'
        switch (this.props.title) {
            case 'Exportar':
                icon = <Icon className={iconClass} path={mdiExportVariant} size={iconSize} color={iconColor} />
                break;
            case 'Agregar':
                icon = <Icon className={iconClass} path={mdiTextBoxPlusOutline} size={iconSize} color={iconColor} />
                break;
            case 'Editar':
                icon = <Icon className={iconClass} path={mdiPencil} size={iconSize} color={iconColor} />
                break;
            case 'Agrupar':
                icon = <Icon className={iconClass} path={mdiBlurRadial} size={iconSize} color={iconColor} />
                break;
        
            default:
                break;
        }
        return (
            <div>
                <div className="popup-menu-button card-color d-flex align-items-center justify-content-between" ref={ref => this.button = ref}>
                    <div className='d-inline-flex d-flex align-items-center'>
                        {icon}
                        <p>{buttonName}</p>
                    </div>
                    <div className='d-inline-flex mr-2'>
                        { this.props.smallScreen ?
                                this.props.active ? <GoTriangleDown size={25}/> : <GoTriangleRight size={25}/> :
                                this.props.active ? <GoTriangleRight size={25}/> : <GoTriangleDown size={25}/>
                        }
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DropdownButton)